import { Button } from '@displate/styleguide';
import styled, { keyframes } from 'styled-components';

import { StaticImage } from '@/common/constants/displateRoutes';

const wishlistAnimation = keyframes`
  0% {
    transform: scale(.8);
  }

  50% {
    transform: scale(1);
  }

  100% {
    transform: scale(.8);
  }
`;

export const WishlistButtonStyled = styled(Button)<{
  isInWishlist?: boolean;
  isAddingToWishlist?: boolean;
  isRemovingFromWishlist?: boolean;
  $color?: string;
}>`
  && {
    display: flex;
    width: 40px;
    height: 40px;
    padding: 0;
    border-radius: 50%;
    background-color: ${({ theme }) => theme.colors.ui01};
    ${({ isAddingToWishlist, isRemovingFromWishlist }) =>
      (isAddingToWishlist || isRemovingFromWishlist) && `pointer-events: none;`};

    &::before {
      content: '';
      position: absolute;
      background-image: ${({ $color }) =>
        `url(${
          $color === 'black'
            ? StaticImage('/images/wishlist/heart_black.svg')
            : StaticImage('/images/wishlist/heart_white.svg')
        })`};
      animation-duration: 1000ms;
      animation-timing-function: steps(60);
      animation-fill-mode: both;
      animation-name: ${({ isAddingToWishlist, isRemovingFromWishlist }) =>
        isAddingToWishlist || isRemovingFromWishlist ? wishlistAnimation : 'none'};
      ${({ isAddingToWishlist }) => isAddingToWishlist && `animation-direction: normal;`}
      ${({ isRemovingFromWishlist }) => isRemovingFromWishlist && `animation-direction: reverse;`}
      width: 36px;
      height: 36px;
      background-size: 140px;
      background-repeat: no-repeat;
      transform: scale(0.8);
      background-position: ${({ isInWishlist, isAddingToWishlist, isRemovingFromWishlist }) =>
        (isInWishlist || isAddingToWishlist) && !isRemovingFromWishlist
          ? '-24px -40%'
          : '7px -40%'};
    }

    &:hover {
      background-color: ${({ theme }) => theme.colors.ui01};
    }
  }
`;
